import React from 'react';
import { Box, Grid, KeyValue, Pill, Typography } from 'web-library';
import { TFunction, useTranslation } from 'react-i18next';

import { useStyles } from './style';
import { PaymentStatus } from '../../../../models/PaymentStatus';

const AdditionalTextForBankTransfer = ({
  classes,
  t,
}: {
  classes: Record<string,string>;
  t: TFunction<'translation'>;
}) => (
  <Typography variant="body1" className={classes.additionalText}>
    {t('exam->>RegistrationSummary.ApplicationPendingConfirmation')}
  </Typography>
);

interface PaymentDetailsProps {
  internalTransactionRef: string;
  transactionNo: string;
  paymentMode: string;
  paymentStatus: string;
}

const PaymentDetails = ({ paymentDetails }: { paymentDetails: PaymentDetailsProps }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { internalTransactionRef, transactionNo, paymentMode, paymentStatus } = paymentDetails;

  return (
    <Box className={classes.container}>
      <Typography variant="h3" className={classes.subheader}>
        {t('exam->>TransactionDetails.PaymentDetails')}
      </Typography>
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            keyText={t('exam->>TransactionDetails.RefNo')}
            valueText={internalTransactionRef}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            keyText={t('exam->>TransactionDetails.TransactionNo')}
            valueText={transactionNo}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid md={6} xs={12}>
          <KeyValue
            keyText={t('exam->>TransactionDetails.PaymentMethod')}
            valueText={paymentMode}
          />
        </Grid>
        <Grid md={6} xs={12}>
          <KeyValue
            keyText={t('exam->>TransactionDetails.PaymentStatus')}
            valueText={
              <Pill
                variant={paymentStatus === 'Paid' ? 'positive' : 'info'}
                label={paymentStatus || ''}
              />
            }
            noPadding
          />
          {paymentStatus === PaymentStatus.NA && (
            <AdditionalTextForBankTransfer classes={classes} t={t} />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentDetails;
